import React from "react";
import { cn } from "./cn";
import { CheckIcon } from "../../../assets/ui/icons";

/* Confirmation mark — a tick in a soft green disc.
 *
 * Decorative: the heading beside it carries the message, so announcing the
 * glyph too would just repeat it. */
export const SuccessMark = ({ size = 72, className = "" }) => (
  <span
    aria-hidden="true"
    className={cn(
      "inline-flex items-center justify-center rounded-full bg-[var(--success-soft)]",
      className
    )}
    style={{ width: size, height: size }}
  >
    <CheckIcon size={Math.round(size * 0.42)} stroke="var(--success)" />
  </span>
);

export default SuccessMark;
